import { supabase } from "../supabase/SupabaseClient";

/* Radicación DNRPA (Registro Seccional, dirección, localidad, provincia) por
 * dominio, vía fibot-vehicle-intelligence. Mismo diseño de dos pasos que
 * `multas.js` y por el mismo motivo: `consultarRadicacion` sólo pega afuera
 * (la edge function, que no toca la base) y `registrarConsulta` es el que
 * guarda -- así el guardado corre con el JWT de quien está mirando la
 * pantalla, y `radicacion_registrar_consulta` puede verificar
 * `cargar.documentos` de verdad en vez de confiar en lo que ya pasó por la
 * edge function.
 *
 * NO TRAE TITULARIDAD NI FECHA DE ALTA -- ninguna de las dos las expone el
 * servicio (ver el docstring del provider en fibot-vehicle-intelligence).
 * Tampoco confirma que la patente exista: es sólo el Registro Seccional al
 * que mapea el dominio consultado.
 */

export const consultarRadicacion = async (dominio) => {
  try {
    const { data, error: fnError } = await supabase.functions.invoke(
      "consultar-radicacion",
      { body: { dominio } },
    );

    if (fnError || data?.error) {
      let mensajeReal = data?.error;
      if (!mensajeReal && fnError?.context?.json) {
        try {
          const body = await fnError.context.json();
          mensajeReal = body?.error;
        } catch {
          // el body no era JSON (ej. timeout del gateway) -- seguimos con
          // fnError.message.
        }
      }
      return {
        data: null,
        error: mensajeReal || fnError?.message || "Error desconocido",
      };
    }

    return { data, error: null };
  } catch (e) {
    return { data: null, error: e?.message || "Error desconocido" };
  }
};

// Guarda lo que trajo `consultarRadicacion`. `resultado` es la respuesta
// cruda de fibot-vehicle-intelligence: { status, radicacion, warning }.
export async function registrarConsulta(dominio, resultado) {
  const r = resultado?.radicacion || {};
  const { error } = await supabase.rpc("radicacion_registrar_consulta", {
    p_dominio: dominio,
    p_tipo_vehiculo: r.tipo_vehiculo ?? null,
    p_registro_numero: r.registro_numero ?? null,
    p_registro_nombre: r.registro_nombre ?? null,
    p_direccion: r.direccion ?? null,
    p_localidad: r.localidad ?? null,
    p_provincia: r.provincia ?? null,
    p_codigo_postal: r.codigo_postal ?? null,
    p_telefono: r.telefono ?? null,
  });
  if (error) throw new Error(error.message);
}

// Consulta en vivo y guarda de una. Es lo que usa el botón de la ficha.
export async function consultarYRegistrarRadicacion(dominio) {
  const { data, error } = await consultarRadicacion(dominio);
  if (error) throw new Error(error);
  if (data?.status === "ok" && data?.radicacion) {
    await registrarConsulta(dominio, data);
  }
  return data;
}

export async function radicacionDe(dominio) {
  const { data, error } = await supabase.rpc("radicacion_de", { p_dominio: dominio });
  if (error) throw new Error(error.message);
  return data?.[0] || null;
}
